'use strict';

var _ = require('lodash');
var PricingDepartureDatesLegendFilterService = function PricingDepartureDatesLegendFilterService(configurationService, App) {
  var markets = {};
  var DEFAULT_DIRECTION = 'OUTBOUND';
  var selectedMarket, selectedPos, selectedCabin, selectedCarrier, selectedDepartureDate, selectedRunNumber;
  var selectedDirection = DEFAULT_DIRECTION;
  var customDefaultCabin, customDefaultDirection, customDefaultMarket, customDefaultRunNumber;
  function reset() {
    markets = {};
    selectedMarket = null;
    selectedPos = null;
    selectedCabin = null;
    selectedRunNumber = null;
    selectedDirection = DEFAULT_DIRECTION;
  }
  function setFilters(departureDatesData) {
    _.forEach(departureDatesData, function (marketData, market) {
      _.set(markets, [market], _.groupBy(departureDatesData[market], 'pos'), []);
      _.each(markets[market], function (posData, pos) {
        _.set(markets, [market, pos], _.keys(_.groupBy(posData, 'cabinCode')), []);
      });
    });
  }
  function getMarkets() {
    return _.keys(markets).sort();
  }
  function orderByLowestCabin(cabins) {
    return _.chain(cabins).uniq().orderBy([function (cabin) {
      return _.get(_.find(App.cabinsConfig, {
        cabinCode: cabin
      }), 'cabinIndex', 0);
    }], ['desc']).value();
  }
  function getPoses(selectedMarket) {
    var market = _.get(markets, [selectedMarket], {});
    return _.keys(market).sort();
  }
  function getCabins(selectedMarket, selectedPos) {
    var cabins = _.get(markets, [selectedMarket, selectedPos], []);
    return orderByLowestCabin(_.intersection(configurationService.getCabins(), cabins));
  }
  function setInitialFilter() {
    selectedMarket = customDefaultMarket || selectedMarket || _.first(getMarkets());
    selectedPos = selectedPos || _.first(getPoses(selectedMarket));
    selectedCabin = customDefaultCabin || selectedCabin || _.first(getCabins(selectedMarket, selectedPos));
    selectedDirection = customDefaultDirection || selectedDirection;
    selectedRunNumber = customDefaultRunNumber || selectedRunNumber;
    customDefaultDirection = null;
    customDefaultCabin = null;
    customDefaultMarket = null;
    customDefaultRunNumber = null;
  }
  function getSelectedMarket() {
    if (!selectedMarket) {
      setInitialFilter();
    }
    return selectedMarket;
  }
  function getSelectedPos() {
    if (!selectedPos) {
      setInitialFilter();
    }
    return selectedPos;
  }
  function getSelectedCabin() {
    if (!selectedCabin) {
      setInitialFilter();
    }
    return selectedCabin;
  }
  function getSelectedDirection() {
    return selectedDirection;
  }
  function getSelectedCarrier() {
    return selectedCarrier;
  }
  function getSelectedDepartureDate() {
    return selectedDepartureDate;
  }
  function getSelectedRunNumber() {
    return selectedRunNumber;
  }
  function setSelectedMarket(newSelectedMarket) {
    selectedMarket = newSelectedMarket;
    return selectedMarket;
  }
  function setSelectedPos(newSelectedPos) {
    selectedPos = newSelectedPos;
    return selectedPos;
  }
  function setSelectedCabin(newSelectedCabin) {
    selectedCabin = newSelectedCabin;
    return selectedCabin;
  }
  function setSelectedDirection(direction) {
    selectedDirection = direction;
    return direction;
  }
  function setSelectedCarrier(newSelectedCarrier) {
    selectedCarrier = newSelectedCarrier;
    return selectedCarrier;
  }
  function setSelectedDepartureDate(newDepartureDate) {
    selectedDepartureDate = newDepartureDate;
    return selectedDepartureDate;
  }
  function setSelectedRunNumber(newRunNumber) {
    selectedRunNumber = newRunNumber;
    return selectedRunNumber;
  }
  function setCustomDefaultRunNumber(newRunNumber) {
    customDefaultRunNumber = newRunNumber;
    selectedRunNumber = newRunNumber;
  }
  function setCustomDefaultCabin(newCabinCode) {
    customDefaultCabin = newCabinCode;
    selectedCabin = newCabinCode;
  }
  function setCustomDefaultDirection(newDirection) {
    customDefaultDirection = newDirection;
    selectedDirection = newDirection;
  }
  function setCustomDefaultMarket(newMarket) {
    customDefaultMarket = newMarket;
  }
  function getCustomDefaultCabin() {
    return customDefaultCabin;
  }
  function getCustomDefaultDirection() {
    return customDefaultDirection;
  }
  return {
    setFilters: setFilters,
    getMarkets: getMarkets,
    getPoses: getPoses,
    getCabins: getCabins,
    setInitialFilter: setInitialFilter,
    getSelectedMarket: getSelectedMarket,
    getSelectedPos: getSelectedPos,
    getSelectedCabin: getSelectedCabin,
    getSelectedDirection: getSelectedDirection,
    getSelectedCarrier: getSelectedCarrier,
    getSelectedDepartureDate: getSelectedDepartureDate,
    getSelectedRunNumber: getSelectedRunNumber,
    setSelectedRunNumber: setSelectedRunNumber,
    setSelectedMarket: setSelectedMarket,
    setSelectedPos: setSelectedPos,
    setSelectedCabin: setSelectedCabin,
    setSelectedDirection: setSelectedDirection,
    setSelectedCarrier: setSelectedCarrier,
    setSelectedDepartureDate: setSelectedDepartureDate,
    setCustomDefaultCabin: setCustomDefaultCabin,
    setCustomDefaultDirection: setCustomDefaultDirection,
    setCustomDefaultMarket: setCustomDefaultMarket,
    setCustomDefaultRunNumber: setCustomDefaultRunNumber,
    getCustomDefaultCabin: getCustomDefaultCabin,
    getCustomDefaultDirection: getCustomDefaultDirection,
    reset: reset
  };
};
PricingDepartureDatesLegendFilterService.$inject = ['ConfigurationService', 'App'];
module.exports = PricingDepartureDatesLegendFilterService;